module.exports = __webpack_public_path__ + "img/10-install-step-5-setup.8191b26c.webp";